import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { ReactSVG } from 'react-svg';
import { lighten } from 'polished';


export const Category = ({ name, icon, ...props }) => (
    <CategoryButton {...props} >
        {icon && <CategoryIcon><ReactSVG src={icon.url} /></CategoryIcon>}
        <CategoryText className="" dangerouslySetInnerHTML={{ __html: name }}/>
    </CategoryButton>
);


const CategoryMenu = ({ categories, defaultCategory, onChange }) => {
    const [ currentCategory, setCurrentCategory ] = useState(defaultCategory || null);
    
    // const filteredCategories = filter(categories, (cat) => cat.count > 0);
    const filteredCategories = categories;
    
    return (
        <Container>
            {filteredCategories.map((category) => (
                <Category
                    className={currentCategory === category.id ? 'selected' : ''}
                    key={category.id}
                    name={category.name}
                    icon={category.acf.menu_icon}
                    selected={currentCategory === category.id}
                    onClick={() => {
                        if (category.id !== currentCategory) {
                            setCurrentCategory(category.id);
                            onChange(category.id);
                        }
                    }}
                />
            ))}
        </Container>
    );
};


export default CategoryMenu;


const Container = styled.div`
    display: flex;
    gap: 2rem;

    padding: 1.5rem 3.5rem;
    background-color: ${props => lighten(0.06, props.theme.secondary_color_light)};
    box-shadow: 0 0 1.75rem rgba(0, 0, 0, 0.15);
`;


const CategoryIcon = styled.div`
    margin-right: 1.2rem;
    width: 3rem;
    height: auto;
    transition: all .3s;
    
    svg {
        width: 100%;
        height: auto;
        display: block;
    }
    
    svg circle {
        fill: currentColor;
    }
`;

const CategoryText = styled.span`
    white-space: nowrap;
    text-transform: uppercase;
    transition: all .3s;
`;

const CategoryButton = styled.button`
    border: none !important;
    outline: none !important;
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    color: ${props => props.theme.primary_color};
    background-color: transparent;
    transition: color .3s;
    
    pointer-events: ${props => (props.selected ? 'none' : 'auto')};

    &:hover {
        color: ${props => props.theme.primary_color_mid};
    }

    &.selected {
        color: ${props => props.theme.secondary_color};
    }
`;